module.exports = __webpack_public_path__ + "img/team_robert_slensvik.6c8342ff.webp";